"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VisuallyHiddenStyles = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _theme = require("../theme");

var _core = require("@emotion/core");

var VisuallyHiddenStyles = {
  border: 0,
  // incase there's a global border
  clip: 'rect(0 0 0 0)',
  // in case someone cliping
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  // incase there's a global padding
  position: 'absolute',
  width: 1
};
exports.VisuallyHiddenStyles = VisuallyHiddenStyles;
var VisuallyHiddenUI = (0, _theme.styled)(_Box.default)(VisuallyHiddenStyles);

var VisuallyHidden = function VisuallyHidden(props) {
  return (0, _core.jsx)(VisuallyHiddenUI, props);
};

var _default = VisuallyHidden;
exports.default = _default;